class Tracking {

  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    this.downloadsTracking();
  }

  downloadsTracking() {
    if (!document.body.classList.contains('page-template-page-downloadcenter')) {
      return;
    }

    const dlcItems = document.querySelectorAll('.downloadcenter-item');

    dlcItems.forEach(item => {
      const filename = item.dataset.filename;
      item.addEventListener('click', (e) => {
        window.dataLayer.push({
          event: 'ga4_event',
          event_name: 'file_download',
          file_download: {
            file_name: filename,
            eventCategory: 'Downloads',
            eventAction: 'Direct Download',
            eventLabel: filename
          }
        });
      });
    });
  }
}

export default Tracking;
